<section class="main-banner">
    <div class="wrapper">
        <div class="banner" *ngIf="banner">
            <div class="two-col">
                <div class="info">
                    <p class="flex"><mat-icon>arrow_forward</mat-icon>{{banner.tipo}}</p>
                    <h2>{{banner.texto_alternativo}}</h2>
                    <p [innerHTML]="banner.link"></p>
                    <button (click)="scrollToForm()">Solicitar asesoría<mat-icon>arrow_forward</mat-icon></button>
                </div>
                <img *ngIf="banner && banner.image" [src]="banner.image.src" [alt]="banner.image.alternativeText">
            </div>
        </div>
    </div>
</section>

<section class="leasing-info">
    <div class="wrapper">
        <div class="info">
            <h1>Tu vehículo con <b>Leasing</b> BitCar</h1>
            <p><b>Leasing</b> es un esquema novedoso y flexible para <b>disfrutar</b> de un auto <b>sin la carga
                    administrativa</b> de ser propietario. Menos preocupaciones, más beneficios.</p>
            <div class="env">
                <p>Somos parte de </p>
                <img src="./assets/img/landing-ex/tip.png" alt="banner">
            </div>
        </div>
        <div class="three-col">
            <div class="mini-card">
                <div class="icon">
                    <img src="./assets/img/landing-ex/user-security.svg" alt="confianza">
                </div>
                <p>Ofrecemos confianza y seguridad</p>
            </div>
            <div class="mini-card">
                <div class="icon">
                    <img src="./assets/img/landing-ex/heart-hand.svg" alt="integrales">
                </div>
                <p>Servicios integrales</p>
            </div>
            <div class="mini-card">
                <div class="icon">
                    <img src="./assets/img/landing-ex/service.svg" alt="asesoria">
                </div>
                <p>Asesorías personalizadas</p>
            </div>
        </div>
    </div>
</section>

<section class="why">
    <div class="two-col">
        <div class="img">
            <img *ngIf="bannerCaracteristicas" [src]="bannerCaracteristicas.src" [alt]="bannerCaracteristicas.alternativeText">
        </div>
        <div class="info">
            <h2>Si te gusta <b>cambiar de vehículo</b> frecuentemente, el Leasing es para ti</h2>
            <p>Te ofrecemos Leasing, Rent2buy y Renting de acuerdo con tus necesidades y preferencias, siempre acompañado de servicios integrales: </p>
            <ul>
                <li>
                    <div class="icon" [ngClass]="{'active' : feature === 0}">
                        <mat-icon>star</mat-icon>
                    </div>
                    <p>Reduce tu pago inicial y evita descapitalizarte.</p>
                </li>
                <li>
                    <div class="icon" [ngClass]="{'active' : feature === 1}">
                        <mat-icon>calendar_today</mat-icon>
                    </div>
                    <p>Con Leasing nosotros nos encargamos del vehículo al finalizar el plazo.</p>
                </li>
                <li>
                    <div class="icon" [ngClass]="{'active' : feature === 2}">
                        <mat-icon>payments</mat-icon>
                    </div>
                    <p>¿Te gustó el vehículo? con Rent2Buy puedes comprarlo a precio preferencial.</p>
                </li>
                <li>
                    <div class="icon" [ngClass]="{'active' : feature === 3}">
                        <mat-icon>verified_user</mat-icon>
                    </div>
                    <p>Despreocúpate, con nosotros obtienes seguros, vehículo sustituto, gestión de mantenimiento
                        incluido y mucho más.</p>
                </li>
            </ul>
            <button (click)="scrollToForm()">Solicitar asesoría <mat-icon>arrow_forward</mat-icon></button>
        </div>
    </div>
</section>

<section class="options">
    <div class="center-title">
        <h2>Tu vehículo, <b>tus opciones de financiamiento</b> A Tu Manera</h2>
    </div>

    <div class="three-col">
        <div class="card">
            <div class="top">
                <mat-icon>check_circle</mat-icon>
            </div>
            <div class="info">
                <div class="center">
                    <h3><b>Leasing</b></h3>
                </div>
                <ul>
                    <li>
                        <mat-icon>check</mat-icon>
                        <p>Arrendamiento financiero, con pago inicial desde 1 mensualidad. </p>
                    </li>
                    <li>
                        <mat-icon>check</mat-icon>
                        <p>Es para ti, si quieres estrenar frecuentemente.</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="card">
            <div class="top">
                <mat-icon>check_circle</mat-icon>
            </div>
            <div class="info">
                <div class="center">
                    <h3><b>Rent2Buy</b></h3>
                </div>
                <ul>
                    <li>
                        <mat-icon>check</mat-icon>
                        <p>Si quieres probar modelos, autos eléctricos o nuevas tecnologías, es tu opción. </p>
                    </li>
                    <li>
                        <mat-icon>check</mat-icon>
                        <p>Al final del plazo la unidad puede ser tuya por un precio por debajo de mercado.</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="card">
            <div class="top">
                <mat-icon>check_circle</mat-icon>
            </div>
            <div class="info">
                <div class="center">
                    <h3><b>Renting</b></h3>
                </div>
                <ul>
                    <li>
                        <mat-icon>check</mat-icon>
                        <p>Con Renting tendrás servicios integrales que te permiten usar tu auto sin preocupaciones.
                        </p>
                    </li>
                    <li>
                        <mat-icon>check</mat-icon>
                        <p>Es ideal para ti, si tienes una vida ocupada.</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="requisitos">
    <div class="wrapper">
        <div class="two-col">
            <h2><b>Vehículo eléctrico</b> o <b>híbrido</b> con BitCar</h2>
            <div class="info-border">
                <p>Tenemos el financiamiento ideal para probar tecnologías nuevas como los vehículos híbridos o eléctricos.</p>
            </div>
        </div>

        <div class="two-col">
            <div class="info">
                <p>Junto con nuestro financiamiento, te brindamos asesoría exclusiva:</p>
                <ul>
                    <li>
                        <div class="icon" [ngClass]="{'active' : feature === 0}">
                            <mat-icon>star</mat-icon>
                        </div>
                        <p>Uso y cuidado de baterías</p>
                    </li>
                    <li>
                        <div class="icon" [ngClass]="{'active' : feature === 1}">
                            <mat-icon>check_circle</mat-icon>
                        </div>
                        <p>Centros de carga</p>
                    </li>
                    <li>
                        <div class="icon" [ngClass]="{'active' : feature === 2}">
                            <mat-icon>check_circle</mat-icon>
                        </div>
                        <p>Mantenimiento ideal para tu vehículo</p>
                    </li>
                    <li>
                        <div class="icon" [ngClass]="{'active' : feature === 3}">
                            <mat-icon>check_circle</mat-icon>
                        </div>
                        <p>Ciudados y precauciones de uso</p>
                    </li>
                </ul>
                <p><b>Tenemos una alianza </b>con <b>VEMO, líder en el mercado de uso de vehículos eléctricos</b>, hacemos equipo para cuidar de ti y tu vehículo.</p>
                <button (click)="scrollToForm()">Solicitar asesoría <mat-icon>arrow_forward</mat-icon></button>
            </div>
            <div class="img">
                <img *ngIf="bannerHibrido" [src]="bannerHibrido.src" [alt]="bannerHibrido.alternativeText">
            </div>
        </div>
    </div>
</section>

<section class="mejor-opcion">
    <div class="wrapper">
        <div class="two-col title">
            <h2>Con el Leasing de BitCar <b>cuiadamos tus finanzas</b></h2>
            <div class="info-border">
                <p>Antes de aprobar tu Leasing automotriz, revisamos tus documentos para asegurarnos de que el plan se adapte a tus posibilidades y no comprometa tu estabilidad financiera. Estos son los requisitos básicos para personas asalariadas:</p>
            </div>

        </div>
        <div class="two-col">
            <div class="img">
                <img *ngIf="bannerRequisitos" [src]="bannerRequisitos.src" [alt]="bannerRequisitos.alternativeText">
            </div>
            <div class="info">
                <div class="two-col">
                    <div class="mini-card">
                        <h3>01</h3>
                        <p>Recibos de nómina y/o estados de cuenta</p>
                    </div>
                    <div class="mini-card">
                        <h3>02</h3>
                        <p>Comprobante de domicilio</p>
                    </div>
                    <div class="mini-card">
                        <h3>03</h3>
                        <p>Constancia de situación fiscal</p>
                    </div>
                    <div class="mini-card">
                        <h3>04</h3>
                        <p>Identificación oficial</p>
                    </div>
                </div>
                <div class="mini-card tip">
                    <div class="icon">
                        <mat-icon>info</mat-icon>
                    </div>
                    <p>Además, vamos a requerir una precalificación digital con datos adicionales sobre tus ingresos, historial crediticio y datos demográficos.</p>
                </div>
            </div>
        </div>        
    </div>

    <div class="brands" #asesoria>
        <div class="brands-wrapper">
            <div class="carrousel">
                <span>Honda</span>
                <span>Toyota</span>
                <span>Hyundai</span>
                <span>KIA</span>
                <span>Chevrolet</span>
                <span>Ford</span>
                <span>Renault</span>
                <span>BMW</span>
                <span>Ford</span>
                <span>Jeep</span>
                <span>Mazda</span>
                <span>Mercedes</span>
                <span>Mini</span>
                <span>Nissan</span>
                <span>Seat</span>
                <span>Suzuki</span>
            </div>
        </div>
    </div>
</section>

<section class="asesoria">
    <app-asesoria-form type="Landing Page Leasing"></app-asesoria-form>
</section>